import React, { useRef } from 'react'
import styled from 'styled-components'
import useClickOutside from '@/utils/hooks/useClickOutside'
import { AddonType } from '../../types'
import { useTranslate } from '@ur-solutions/react-hooks'
import { DetectBlur } from '@/containers/util-containers'
import { useCompany } from '@/utils/hooks'

const Wrapper = styled.aside`
  position: absolute;
  z-index: 1000;
  top: 0;
  right: -20px;
  min-width: 100%;

  background-color: ${props => props.theme.colors.secondary};
  border-radius: ${props => props.theme.sizes.defaultBorderRadius};
  overflow: hidden;
  cursor: pointer;
  box-shadow: 2px 6px 24px 0px #00305777;

  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    padding: 3px 0.4rem 0;
    color: ${props => props.theme.colors.text.dark};

    font-weight: 600;
    font-size: 0.75rem;
    z-index: 1000;

    & + div {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
`

interface SelectAddonTypeProps {
  open: boolean
  onClose: () => void
  onSubmit: (type: keyof typeof AddonType) => void
}

export const SelectAddonType: React.FC<SelectAddonTypeProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const translations = useTranslate({
    TIME: 'salary.time-addons',
    FIXED: 'salary.fixed-addons',
    OVERRIDE: 'salary.override-other-addons',
  })
  const wrapperRef = useRef<HTMLElement>(null)
  const company = useCompany()

  useClickOutside(wrapperRef, () => onClose(), true)

  if (!open) return null

  return (
    <DetectBlur active={open} onClickOutside={onClose}>
      <Wrapper ref={wrapperRef}>
        {Object.values(AddonType)
          .filter(
            addon =>
              (company.shortName !== 'kristensen' &&
                addon !== AddonType.OVERRIDE) ||
              (company.shortName === 'kristensen' && addon === AddonType.TIME)
          )
          .map(addon => (
            <div
              key={addon}
              onClick={evt => {
                evt.stopPropagation()
                onSubmit(addon)
              }}
            >
              {translations[addon]}
            </div>
          ))}
      </Wrapper>
    </DetectBlur>
  )
}
